export const interpolate = (
  text = '',
  variables: Record<string, string> = {},
) =>
  Object.entries(variables).reduce(
    (t, [key, value]) => t.replace(new RegExp(`{${key}}`, 'g'), value),
    text,
  );
